import { PAGE_REPLACED_HEAD, PAGE_REPLACED_BODY, INTERNAL_LIGHTHUB_KEEP_ONCE } from "./const";

import { getGlobalLightHub, isIgnoreScript } from "./utils";

import nprogress from 'nprogress';

/**
 * 有些特殊的 HTML 无法用 DOM 解析，例如 head，body 等，替换成 <pagemod-replaced-head> 这样
 * @param html 
 */
function replaceSpecialElement(html: string): string {
    const replacer = [
        [/<head([^]*?)>/, `<${PAGE_REPLACED_HEAD}$1>`],
        ['</head>', `<\/${PAGE_REPLACED_HEAD}>`],
        [/<body([^]*?)>/, `<${PAGE_REPLACED_BODY}$1>`],
        ['</body>', `<\/${PAGE_REPLACED_BODY}>`],
    ];

    let result = html;
    for (let item of replacer) {
        result = result.replace(item[0], item[1] as string);
    }

    return result;
}

function parseHTML(html: string) {
    const tag = document.createElement('div');
    tag.innerHTML = html;

    const body = getBodyOfDOM(tag);

    const children = Array.from(tag.children);
    const index = children.indexOf(body);

    // 把 body 后面多出来的东西也塞到 body 里
    children.slice(index + 1).forEach(item => {
      body.appendChild(item);
    });
    return tag;
}

function getHeadOfDOM(dom: Element) {
    return dom.getElementsByTagName(PAGE_REPLACED_HEAD)[0];
}

function getBodyOfDOM(dom: Element) {
    return dom.getElementsByTagName(PAGE_REPLACED_BODY)[0];
}

const slideCSS = `#lighthub-skeleton-image {
  animation: lighthub-slide-in 300ms forwards;
  -webkit-animation: lighthub-slide-in 300ms forwards;
  transform: translate3d(100%, 0, 0);
  backface-visibility: hidden;
  perspective: 1000;
}


@keyframes lighthub-slide-in {
  0% { 		
    transform: translate3d(60%, 0, 0);
  }

  100% { 	
    transform: translate3d(0, 0, 0);
  } 
}

#lighthub-skeleton-image {
  visibility: visible;
}

body,html {
  padding: 0;
  margin: 0;
}
`;
const nprogressCSS = `

/* Make clicks pass-through */
#nprogress {
  pointer-events: none;
  visibility: visible;
}

#nprogress .bar {
  background: #29d;

  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  visibility: visible;

  width: 100%;
  height: 2px;
}

/* Fancy blur effect */
#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #29d, 0 0 5px #29d;
  opacity: 1.0;
  visibility: visible;

  -webkit-transform: rotate(3deg) translate(0px, -4px);
      -ms-transform: rotate(3deg) translate(0px, -4px);
          transform: rotate(3deg) translate(0px, -4px);
}

/* Remove these to get rid of the spinner */
#nprogress .spinner {
  display: block;
  position: fixed;
  z-index: 1031;
  top: 15px;
  right: 15px;
  visibility: visible;
}

#nprogress .spinner-icon {
  width: 18px;
  height: 18px;
  box-sizing: border-box;

  border: solid 2px transparent;
  border-top-color: #29d;
  border-left-color: #29d;
  border-radius: 50%;
  visibility: visible;

  -webkit-animation: nprogress-spinner 400ms linear infinite;
          animation: nprogress-spinner 400ms linear infinite;
}

.nprogress-custom-parent {
  overflow: hidden;
  position: relative;
}

.nprogress-custom-parent #nprogress .spinner,
.nprogress-custom-parent #nprogress .bar {
  position: absolute;
}

@-webkit-keyframes nprogress-spinner {
  0%   { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes nprogress-spinner {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

`;

export function animationNextPage(skeletonElement: HTMLElement) {
    const tag = document.createElement('style');

    if (skeletonElement) {
      const style = document.createElement('style');
      style.innerHTML = nprogressCSS;
      style.setAttribute(INTERNAL_LIGHTHUB_KEEP_ONCE, 'true');
      document.body.appendChild(style);

      const slideStyle = document.createElement('style');
      slideStyle.innerHTML = slideCSS;
      slideStyle.setAttribute(INTERNAL_LIGHTHUB_KEEP_ONCE, 'true');

      // const skeletonElement = document.createElement('img');
      skeletonElement.id = 'lighthub-skeleton-image';
      skeletonElement.style.width = '100%';
      skeletonElement.style.minHeight = '100%';
      skeletonElement.style.position = 'absolute';
      // @ts-ignore
      skeletonElement.style.left = 0;
      // @ts-ignore
      skeletonElement.style.top = 0;
      skeletonElement.style.visibility = 'visible';
      skeletonElement.setAttribute(INTERNAL_LIGHTHUB_KEEP_ONCE, 'true');
      // @ts-ignore
      skeletonElement.style.zIndex = -99999;
      skeletonElement.style.willChange = 'transform';

      // skeletonElement.src = skeleton;

      const bodyHiddenStyle = document.createElement('style');
      bodyHiddenStyle.innerHTML = `body {visibility: hidden; }`;
      bodyHiddenStyle.id = 'lighthub-body-hidden';
      bodyHiddenStyle.setAttribute(INTERNAL_LIGHTHUB_KEEP_ONCE, 'true');
      document.body.appendChild(bodyHiddenStyle);
      document.body.appendChild(skeletonElement);

      
      document.body.appendChild(slideStyle);
      document.body.appendChild(style);

    }

    nprogress.start();

    window.scroll(0, 0);
 

}

export function getAttrs(ele: Element) {
    const names = ele.getAttributeNames();
    if (!names) return [];
    
    return names.map(key => ({
        key,
        val: ele.getAttribute(key) || ''
    }));
}

function preloadInDOM(dom: HTMLElement) {
  const lighthub = getGlobalLightHub();
  if (!lighthub) return;

  const fetch = lighthub.origins._fetch.bind(window);
 
  dom.querySelectorAll('script[src]').forEach(item => {
    // @ts-ignore
    const src = item.src;
    // TODO
    if (src && !isIgnoreScript(src)) {
      fetch(src);
    }
  });

  dom.querySelectorAll('link[rel="stylesheet"]').forEach(item => {
    // @ts-ignore
    item.href && fetch(item.href);
  });
}

export function parsePage(source: string) {
    const html = replaceSpecialElement(source);

    const dom = parseHTML(html);
    preloadInDOM(dom);

    const head = getHeadOfDOM(dom);
    const body = getBodyOfDOM(dom);

    const lighthub = getGlobalLightHub();

    return {
        headChildren: Array.from(head.children),
        bodyAttrs: getAttrs(body),
        bodyChildren: Array.from(body.children),
    };
}